import create from 'zustand'

const initialEditForm = {
  id: null,
  name: null,
  address: null,
  province_id: null,
  city_id: null,
  subdistrict_id: null,
  postal_code: null,
  phone: null,
  primary_address: null,
  rajaOngkirId: null,
  provinceName: null,
  cityName: null,
  districtName: null,
  subdistrictName: null,
  type: 'pribadi',
}

export const useEditAddressStore = create(set => ({
  open: false,
  form: { ...initialEditForm },
  onCloseComplete: null,

  openModal: payload => {
    const form = {
      id: payload?.idAddress || payload?.id,
      name: payload?.receiverName || payload?.name || '',
      address: payload?.address,
      province_id: payload?.provinceId,
      city_id: payload?.cityId,
      subdistrict_id: payload?.subdistrictId,
      postal_code: payload?.postalCode,
      phone: payload?.phone,
      primary_address: payload?.primaryAddress,
      rajaOngkirId: payload?.rajaOngkirId,
      provinceName: payload?.province || payload?.provinceName,
      cityName: payload?.cityName,
      districtName: payload?.districtName,
      subdistrictName:
        payload?.subDistrict || payload?.subdistrict || payload?.subdistrictName,
      type: payload?.type,
    }

    const keyword = `${form.subdistrictName} ${form.districtName} ${form.cityName}`

    set({
      open: true,
      form,
      keyword,
    })
  },

  setOnCloseComplete: fn => {
    if (typeof fn === 'function') {
      set({ onCloseComplete: fn })
    }
  },

  clearOnCloseComplete: () => set({ onCloseComplete: null }),

  closeModal: () =>
    set({
      open: false,
      keyword: 'jakarta',
      form: { ...initialEditForm },
    }),

  setForm: updater =>
    set(state => ({
      form: typeof updater === 'function' ? updater(state.form) : updater,
    })),
}))
